<template>
    <div>
        <div class="zfb-list">
            <ul>
                <li>
                    <label>订单金额</label>
                    <span class="ts">￥{{amount}}</span>
                </li>
                <li v-if="smsConfirmFlag == 1">
                    <label>手机号</label>
                    <span>{{phone}}</span>
                </li>
                <li v-if="smsConfirmFlag == 1">
                    <label>短信验证码</label>
                    <span><input type="text" pattern="\d*" maxlength="6" v-model="smsCode" placeholder="请输入验证码"></span>
                </li>
            </ul>
        </div>
        <template v-if="smsConfirmFlag == 1">
            <div class="zfb-message">短信验证码已发送至<span>{{phone}}</span></div>
            <van-button
            @click="doSend"
            class="zfb"
            :loading="loading"
            v-if="loading==false"
          >
            确认支付
          </van-button>
            <van-button
            class="zfb2"
            v-else
          >
            确认支付
          </van-button>
            <!--div class="zfb" @click="doSend">确认支付</div-->
        </template>
        <!-- <van-button
            @click="doJump"
            class="zfb"
            :loading="loading"
            v-if="smsConfirmFlag == 0 && loading==false"
          >
            确认支付
          </van-button>
        <van-button
            class="zfb2"
            v-if="smsConfirmFlag == 0 && loading==true"
          >
            确认支付
          </van-button> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            tradeNO:'',//支付订单号
            smsCode:'',//短信验证码
            amount:'',//订单金额
            phone:'',//手机号
            smsConfirmFlag:0,//0 不可发送短信 1可发送短信
            tradeNum:'',//订单号 上送短信验证码需要的订单号
            loading:false,
            appTag:'',
            modeType:'',
            queryUrl:''
        }
    },
    created () {
        document.title="支付宝";
        document.body.style.backgroundColor = "#F7F7F7";
        let smsConfirmFlag = this.$route.query.smsConfirmFlag;//是否可发送短信
        let tradeNO = this.$route.query.tradeNO;//支付订单号,吊起支付宝需要的订单号
        let amount = this.$route.query.amount;//订单金额
        let phone = this.$route.query.phone;//手机号
        let tradeNum = this.$route.query.tradeNum;//上送短信验证码需要的订单号
        let appTag = this.$route.query.appTag;//0 佳付通 1 富裕钱包

        let modeType= this.$route.query.modeType;//0 默认 1 取URL跳转
        if (!!modeType){
            this.modeType=modeType;
            if (modeType=="1"){
                let queryUrl= this.$route.query.url;
                if (!!queryUrl){
                    this.queryUrl=queryUrl;
                }
            }
        }

        if(!!smsConfirmFlag){//是否需要短信验证码
            this.smsConfirmFlag = smsConfirmFlag;
        }
        if(!!tradeNO){//支付订单号
            this.tradeNO = tradeNO;
        }
        if(!!amount){//订单金额
            this.amount = amount;
        }
        if(!!phone){//手机号
            this.phone = phone;
        }
        if(!!tradeNum){//订单号
            this.tradeNum = tradeNum;
        }
        if(!!appTag){
            this.appTag = appTag;
        }
        if(this.smsConfirmFlag == 0 || this.smsConfirmFlag == null){
            this.doJump();
        }
    },
    methods: {
        //不需要短信验证码
        doJump() {
            this.loading = true;
            let url="";
            if (this.modeType == "1") {
                url = encodeURIComponent(this.queryUrl);
                window.location.href="alipays://platformapi/startapp?appId=10000007&qrcode="+url;
            }else {
                url = encodeURIComponent(this.$setUrl.setUrl().hrefUrl+'tuneUpAlipay?tradeNO='+this.tradeNO+'&appTag='+this.appTag);
                window.location.href="alipays://platformapi/startapp?appId=20000067&url="+url;
            }
        },
        //需要短信验证码
        doSend(){
            this.loading = true;
            let params = {};
            params.smsCode = this.smsCode;//短信验证码
            params.tradeNum = this.tradeNum;//订单号
            this.$baseUrl("/trade/aliOrderConfirm", params).then((res) => {
                let data = res.data;
                if (data.code == "0000") {
                    this.tradeNO = data.aliTradeNum;
                    this.doJump();//调起支付宝
                }else {
                    this.$router.push({
                        name:"zfbFail",
                        query:{
                            msg:data.msg
                        }
                    })
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.zfb-list{
    background: #fff;
    padding: 0 15px;
    font-size: 16px;
}
.zfb-list ul li{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E2E2E1;
    padding: 20px 0;
}
.zfb-list ul li input{
    border: none;
    text-align: right;
}
.zfb-list ul li:last-child{
    border-bottom: none;
}
.zfb-list ul li span.ts{
    font-size: 22px;
}
.zfb-message{
    margin-top: 17px;
    font-size: 14px;
    padding-left: 15px;
}
.zfb-message span{
    color: #2069FF;
    padding-left: 5px;
}
.zfb{
    background: #2069FF;
    height: 44px;
    line-height: 44px;
    text-align: center;
    margin: 64px 15px 0;
    color: #fff;
    border-radius: 4px;
    width: calc(100% - 30px);
}
.zfb2{
    background: #C0C4CC;
    height: 44px;
    line-height: 44px;
    text-align: center;
    margin: 64px 15px 0;
    color: #909299;
    border-radius: 4px;
    width: calc(100% - 30px);
}
</style>
